import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import '../styles/Policies.css';

export default function FacilityUseRulesEnglish() {
  return (
    <Container className="facility-use-rules">
      <div className="page-title">
        <h1 style={{ textAlign: 'center' }}>Facility Use Rules</h1>
      </div>
      <Grid className="grid-container">
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              1. Pre-Use Rules
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6">1.1 Eligibility for Use</Typography>
            <ul>
              <li>
                The gym is open to all employees, and registration is required
                to use the gym.
              </li>
              <li>
                Only company employees are allowed to use the gym; external
                individuals are not permitted.
              </li>
            </ul>
            <Typography variant="h6">1.2 Operating Hours</Typography>
            <ul>
              <li>
                The operating hours are Monday to Friday: 11:00 AM - 5:00 PM.
              </li>
              <li>
                Operating hours may change due to public holidays or specific
                circumstances. Any changes will be communicated through the gym
                notice board.
              </li>
              <li>
                Usage is restricted during shift hours, including the lunch
                break. Usage is only allowed before the shift starts or after it
                ends. Please take note.
              </li>
            </ul>
            <Typography variant="h6">
              1.3 Dress Code and Required Items
            </Typography>
            <ul>
              <li>
                Comfortable workout clothes and athletic shoes are required for
                gym use. Slippers, sandals, high heels, or work shoes are not
                permitted.
              </li>
              <li>
                Towels should be brought to keep equipment and facilities clean
                after use.
              </li>
              <li>
                It is recommended to bring a personal water bottle. Drinks can
                only be consumed in designated areas within the gym or in sealed
                bottles.
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              2. In-Use Rules
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6">2.1 Equipment Use</Typography>
            <ul>
              <li>
                Ensure you are familiar with the correct usage of equipment and
                maintain proper form while exercising.
              </li>
              <li>
                Keep a safe distance from others when using equipment. If
                another employee is waiting, finish your workout within a
                reasonable time and give up the equipment.
              </li>
              <li>
                After use, clean and return equipment to its proper place.
              </li>
              <li>
                Do not overuse equipment or use it improperly, and choose a
                weight that is appropriate for your fitness level to avoid
                injury.
              </li>
            </ul>
            <Typography variant="h6">
              2.2 Reservations and Usage Time
            </Typography>
            <ul>
              <li>
                Some facilities require reservations. You may need to book in
                advance for certain equipment or spaces.
              </li>
              <li>
                Failure to show up for a reservation or cancellation without
                notice may result in usage restrictions.
              </li>
              <li>
                If no reservation is made, equipment is available on a
                first-come, first-served basis. Be courteous and yield your spot
                if others are waiting.
              </li>
            </ul>
            <Typography variant="h6">2.3 Maintaining Cleanliness</Typography>
            <ul>
              <li>
                Clean the equipment after use. Use the cleaning supplies and
                towels provided by the gym to wipe down equipment.
              </li>
              <li>
                Dispose of trash properly in the designated bins. Each person is
                responsible for tidying up their personal belongings.
              </li>
            </ul>
            <Typography variant="h6">2.4 Safety Management</Typography>
            <ul>
              <li>Stretch before exercising to prevent injury.</li>
              <li>
                Be cautious not to lift excessive weight, and if using high-risk
                equipment like the bench press, always seek assistance from a
                colleague or trainer.
              </li>
              <li>
                Alcohol and smoking are prohibited in the gym. Only water should
                be consumed during exercise; other food is not allowed.
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              3. Post-Use Rules
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6">3.1 Equipment Organization</Typography>
            <ul>
              <li>
                After exercising, return equipment to its original position,
                such as placing dumbbells and bench press back where they
                belong.
              </li>
              <li>
                Immediately clean the equipment after use, and check its
                condition for the next user.
              </li>
            </ul>
            <Typography variant="h6">3.2 Personal Item Management</Typography>
            <ul>
              <li>
                Each person is responsible for storing their valuables. Do not
                leave valuables in the gym.
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel4-content"
            id="panel4-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              4. Additional Rules
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6">4.1 Music and Noise Management</Typography>
            <ul>
              <li>
                It is recommended to use earphones or headphones while working
                out to avoid unnecessary noise.
              </li>
              <li>
                Avoid speaking loudly or engaging in disruptive behavior that
                may disturb others.
              </li>
            </ul>
            <Typography variant="h6">4.2 Group Exercises</Typography>
            <ul>
              <li>
                If you wish to participate in a group exercise session, prior
                reservation may be required. All participants should attend on
                time.
              </li>
              <li>
                During group exercises, cooperate with others and avoid
                disturbing others while working out.
              </li>
            </ul>
            <Typography variant="h6">4.3 In Case of Injury</Typography>
            <ul>
              <li>
                If an injury occurs, immediately inform the gym manager and take
                necessary actions.
              </li>
              <li>
                Emergency kits are available for use, or you should immediately
                proceed to the nearest hospital if urgent medical treatment is
                required.
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel5-content"
            id="panel5-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              5. CCTV Policy
            </Typography>
            <Typography
              component="span"
              sx={{ fontWeight: '600', color: 'red', ml: 1 }}
            >
              (NEW)
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body1" gutterBottom>
              The Company recognizes that video surveillance systems (“
              <b>CCTV”</b>) and related surveillance equipment can help keep the
              Gym safe, but that it can also violate the personal privacy of
              those who are monitored. This policy has been prepared to help
              establish clear rules around the installation and use of CCTV in
              the Gym.
            </Typography>
            <Typography variant="body1" gutterBottom>
              The Personal Information Protection Act (BC) (“PIPA”) governs the
              collection, use and disclosure of “personal information” which
              includes video images of identifiable individuals. Data collected
              by the use of CCTV in the Gym may be classified as personal
              information under PIPA and other relevant legislation. As such,
              this policy and your privacy rights shall be subject to any such
              legislation as applicable.
            </Typography>
            <Typography variant="body1" gutterBottom>
              To help promote safety, prevent theft or vandalism, and support
              investigations as necessary, the Company has installed CCTV
              cameras in the Gym and adjacent common areas (eg. hallways,
              entrances, and exits) (collectively, the “<b>Facility”</b>). This
              policy applies strictly only to the CCTV operating in the Gym.
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
              <b>
                As such, in using or accessing the GYM, you understand and agree
                that the Gym is monitored by CCTV for safety and security
                purposes.
              </b>
            </Typography>
            <Typography
              variant="h6"
              sx={{ textDecoration: 'underline' }}
              gutterBottom
            >
              CCTV Use
            </Typography>
            <Typography variant="body1" gutterBottom>
              The Company shall abide by the following principles with respect
              to the use of CCTV data:
            </Typography>
            <ol>
              <li>
                <b>Limited Use:</b> The CCTV shall be used strictly for
                security, health, and safety purposes. It shall not be used for
                monitoring the Participant’s use of the Gym, attendance, or
                conduct unless directly related to a security concern, complaint
                investigation, or inadvertently discovered.
              </li>
              <li>
                <b>Signage and Location:</b> The CCTV cameras and monitored
                areas within the Facility shall be indicated by accompanying
                signage to help inform the Participants and any Third-Parties or
                other persons of the operation of video surveillance. The CCTV
                cameras shall not be hidden from view.
              </li>
              <li>
                <b>Surveillance:</b> The CCTV will be in operation 24/7. Any
                data the CCTV collects shall only be accessed and used by
                designated personnels including but not limited to managers and
                security personnel to review the recordings, only when necessary
                (collectively, the “<b>Authorized Personnel</b>”) and in a
                manner that is legal, ethical, professional, and consistent with
                any applicable legislation. Operation of the CCTV shall be
                subject to laws and Company policies related to sexual
                harassment, personal privacy, and respectful workplaces.
              </li>
              <li>
                <b>Access and Retention:</b> Access to recorded data shall be
                restricted to Authorized Personnel or as permitted by law, as
                necessary. Under PIPA, the Participant has the right to request
                access to their own personal information held by the Company.
                Upon such request, the Company may provide footage where the
                footage can blur or remove other individuals to protect the
                privacy of other Participants and Third Parties. Recorded data
                shall only be retained for a limited period in accordance with
                applicable legislation such as PIPA, after which the data shall
                be deleted unless required for an active investigation.
              </li>
              <li>
                <b>General Disclosure:</b> The CCTV data should not be
                transferred to any person or organization outside of the
                Authorized Personnel unless this is required for an
                investigation or legal purposes.
              </li>
              <li>
                <b>Required Disclosure:</b> Access and disclosure restrictions
                to data collected through the use of CCTV shall be subject to
                the following exceptions: law enforcement; government agencies
                and authorities; relevant legal representatives; individuals
                assisting with the identification of a victim, witness, or
                perpetrator; and other individuals or organizations as required
                by law.
              </li>
              <li>
                <b>Data Security:</b> The CCTV data, controls, and related
                servers shall be securely locked and only accessible to
                Authorized Personnel.
              </li>
            </ol>
            <Typography
              variant="h6"
              sx={{ textDecoration: 'underline' }}
              gutterBottom
            >
              Prohibited Use
            </Typography>
            <Typography variant="body1" gutterBottom>
              The CCTV is prohibited from use in any space where individuals
              havae a reasonable expectation of privacy, such as:
            </Typography>
            <ol style={{ marginBottom: '0.35em' }}>
              <li>Changing rooms;</li>
              <li>Washrooms; and</li>
              <li>Shower facilities.</li>
            </ol>
            <Typography variant="body1" gutterBottom>
              Under no circumstances shall CCTV be installed or operated in
              these areas.
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
              Any collection, use, or disclosure of CCTV data for purposes other
              than those listed in this policy are prohibited unless required by
              law or a governing authority. Violations under this policy may
              constitute serious misconduct that may result in disciplinary
              action, up to and including termination with cause.
            </Typography>
            <Typography
              variant="h6"
              sx={{ textDecoration: 'underline' }}
              gutterBottom
            >
              Notice to Participants
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
              Participants are hereby informed of the presence and operation of
              CCTV through this policy. Through this policy and by the use or
              access of the Facility, the Participants are deemed to have
              understood and accepted that they may be recorded.
            </Typography>
            <Typography
              variant="h6"
              sx={{ textDecoration: 'underline' }}
              gutterBottom
            >
              Questions or Concerns
            </Typography>
            <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
              Participants who have questions or concerns about the use and
              operation of CCTV within the Company should contact HR. The
              Company shall take all concerns regarding CCTV seriously and take
              appropriate steps to address any confirmed issues with its use.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel5-content"
            id="panel5-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              6. Penalties
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6">6.1 Penalties for Violations</Typography>
            <ul>
              <li>
                Repeated violations of these rules or actions that compromise
                the safety and convenience of other employees may result in
                restricted access to the gym.
              </li>
              <li>
                For severe violations, access to the gym may be suspended after
                a warning, and the individual may be prohibited from using the
                gym for a certain period of time.
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel6-content"
            id="panel6-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              7. Contact
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul>
              <li>
                Warehouse Manager:{' '}
                <a href="mailto:hyunseok.kim@innofoods.ca">
                  <b>Hyunseok Kim</b>
                </a>
              </li>
              <li>
                Warehouse Admin:{' '}
                <a href="mailto:jungsoon.ahn.@innofoods.ca">
                  <b>Jungsoon Ahn</b>
                </a>
              </li>
              <li>
                HR Coordinator:{' '}
                <a href="mailto:sera.kim@innofoods.ca">
                  <b>Sera Kim</b>
                </a>
              </li>
              <li>
                Tel:{' '}
                <a href="tel:+16047782824;ext=210">604-778-2824, Ext. 210</a>
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ArrowDropDownIcon />}
            aria-controls="panel6-content"
            id="panel6-header"
          >
            <Typography component="span" sx={{ fontWeight: '600' }}>
              8. Website Bug Reporting
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <ul>
              <li>
                Please contact the web developer if you find any errors and/or
                something doesn't work 👩🏻‍💻
              </li>
              <li>
                Webmaster:{' '}
                <a href="mailto:jiyoung.kim@innofoods.ca">
                  <b>Ji Young Kim</b>
                </a>
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Container>
  );
}
